import i18n from 'i18next';
import sprintf from 'i18next-sprintf-postprocessor';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './en';
import ko from './ko';
import ja from './ja';
import de from './de';
import hi from './hi';

const resources = {
	en: {
		translation: en,
	},
	ko: {
		translation: ko,
	},
	ja: {
		translation: ja,
	},
	de: {
		translation: de,
	},
	hi: {
		translation: hi,
	},
};

// 지원하는 언어 목록
export const supportedLanguages = [
	{ code: 'ja', name: '日本語', nativeName: '日本語' },
	{ code: 'en', name: 'English', nativeName: 'English' },
	{ code: 'hi', name: 'हिंदी', nativeName: 'हिंदी' },
	{ code: 'de', name: 'Deutsch', nativeName: 'Deutsch' },
	{ code: 'ko', name: '한국어', nativeName: '한국어' },
];

const LANGUAGE_STORAGE_KEY = 'tamai_language';

export const getBrowserLanguage = () => {
	// localStorage에서 저장된 언어 설정 확인
	const savedLanguage = localStorage.getItem(LANGUAGE_STORAGE_KEY);
	if (savedLanguage && Object.prototype.hasOwnProperty.call(resources, savedLanguage)) {
		return savedLanguage;
	}

	// 브라우저 언어 감지
	const browserLanguage = window.navigator.language || (window.navigator as any).userLanguage;
	let languageCode = browserLanguage.split('-')[0];
	if (languageCode === 'zh') {
		languageCode = browserLanguage;
	}
	const defaultLanguage = 'ja';

	if (Object.prototype.hasOwnProperty.call(resources, languageCode)) {
		return languageCode;
	}

	return defaultLanguage;
};

// 언어 변경 함수
export const changeLanguage = (languageCode: string) => {
	if (Object.prototype.hasOwnProperty.call(resources, languageCode)) {
		localStorage.setItem(LANGUAGE_STORAGE_KEY, languageCode);
		i18n.changeLanguage(languageCode);
		document.documentElement.lang = languageCode;
	}
};

const initialLang = getBrowserLanguage();
console.log(`LANG: ${initialLang}`);
document.documentElement.lang = initialLang;

i18n.use(initReactI18next)
	.use(Backend)
	.use(LanguageDetector)
	.use(sprintf)
	.init({
		resources,
		// lng: "ja",
		lng: initialLang,
		fallbackLng: 'ja',
		debug: false,
		defaultNS: 'translation',
		ns: 'translation',
		interpolation: {
			escapeValue: false, // HTML을 안전하게 렌더링합니다.
			alwaysFormat: true,
			format(value, format, lng) {
				if (format === 'uppercase') return value.toUpperCase();
				// interpolation 되는 값이 number로 들어올 때, 언어 설정에 맞는 locale string으로 변환해서 반환
				if (typeof value === 'number') return value.toLocaleString(lng);
				return value;
			},
		},
		react: {
			defaultTransParent: 'div',
			transEmptyNodeValue: '',
			transSupportBasicHtmlNodes: true,
			// <Trans> 컴포넌트 내부에 들어가는 html 태그들
			transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'button', 'a', 'span', 'div', 'input'],
			transWrapTextNodes: '',
		},
		keySeparator: '.', // 중첩 키 사용 활성화 (예: "common.save")
		nsSeparator: '=>', // default: ':', :가 번역 키에 포함되는 사례가 있어, 번역 키로 사용되지 않을 것 같은 seperator를 설정
	});


// i18next를 파라미터로 넘길 때 사용할 인터페이스 타입
export interface I18Next {
	t: (str: string, option?: Object) => string;
}

// 동적 enum 값 번역 헬퍼 (예: user.level, user.status, contact.contactType)
export const tEnum = (value: string): string => {
	return i18n.t(`enum.${value.toLowerCase()}`);
};

// scanner를 사용하기 위한 dummy function
export const i18nextScanKey = (key: string): string => key;

export default i18n;
